import { request } from "@/request";

//登录状态下课程列表
export function fetchVideoList(params) {
  //course_id  1集中培训2自学
  return request({
    url: `/course`,
    headers: {},
    params
  });
}

//未登状态下课程列表
export function fetchVideoListNotLogin(params) {
  //course_id  1集中培训2自学
  return request({
    url: `/index`,
    headers: {},
    params
  });
}

//课程详情
export function fetchVideoDetail(params) {
  const { course_id } = params;
  return request({
    url: `/course/${course_id}`,
    headers: {}
  });
}

//设置观看视频进度
export function fetchSetVideoProgress(data) {
  const { video_id } = data;
  return request({
    url: `/video/${video_id}`,
    method: "put",
    headers: {},
    data
  });
}

//开始观看视频
export function fetchStartWatchVideo(data) {
  const { video_id } = data;
  return request({
    url: `/video/${video_id}`,
    method: "post",
    headers: {},
    data
  });
}
